// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__qOGQJ","row":"Table_row__1AdNs","thumbnail":"Table_thumbnail__1o4xt"};